<template>
  <div>
    <FilterItems :datasIn="camps" @filtered="updatedDatas"></FilterItems>

    <catalog-table
      :tableHeaders="campHeaders"
      :tableData="newDatas"
      :tableFilters="campFilters"
      :propsToSearch="campSearchableProps"
      :actions="campActions"
      :page-size="50"
      hide-page-size
      hide-footer
    >
      <template v-if="$can('add', 'Highway', 'camp')" slot="search-toolbar-actions">
        <md-button class="md-success" @click="addCamp">
          <span class="md-label">
            <md-icon class="material-icons">add</md-icon>
          </span>
          Agregar
        </md-button>
      </template>
    </catalog-table>
    <modal v-if="editModal" @close="editModalHide">
      <template slot="header">
        <h4 class="info-text">{{ editModalTitle }}</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="editModalHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <camp-edit
          :camp="this.currentCamp"
          :edit="this.modalFunction"
          @saved="updateCamp"
          @error="hideEdit"
        ></camp-edit>
      </template>
    </modal>

    <simple-modal v-if="updatingCampResident">
      <loading-content
        :loading="true"
        loading-label="Actualizando"
        loading-description="Espere unos momentos..."
      />
    </simple-modal>
  </div>
</template>

<script>
import catalogService from "@/services/catalog";
import { CatalogTable } from "@/components/";
import { Modal } from "@/components";
import CampEdit from "./Edit";
import FilterItems from "./Filter";

const campHeaders = {
  name: "Nombre",
  address: "Dirección",
  stateMunicipality: "Estado / Municipio",
};

export default {
  name: "Camps",
  components: {
    CatalogTable,
    Modal,
    CampEdit,
    FilterItems,
  },

  data() {
    return {
      updatingCampResident: false,
      camps: [],
      newDatas: [],
      modalFunction: true,
      editModal: false,
      currentCamp: {},
      editModalTitle: "Editar cliente",
      campFilters: {},
      campHeaders,
      campSearchableProps: Object.keys(campHeaders),
      campActions: [
        {
          icon: "edit",
          exe: this.editCamp,
          showIf: () => this.$can("change", "Highway", "camp"),
        },
        {
          icon: "close",
          exe: this.deleteCamp,
          showIf: () => this.$can("delete", "Highway", "camp"),
        },
      ],
      modelValidations: {
        name: {
          required: true,
        },
        highway: {
          required: true,
        },
        state: {
          required: true,
        },
        municipality: {
          required: true,
        },
      },
    };
  },
  methods: {
    updatedDatas(datas) {
      this.newDatas = datas;
    },
    editModalHide() {
      this.editModal = false;
    },
    editCamp(c) {
      this.modalFunction = true;
      this.editModalTitle = "Editar campamento";
      this.currentCamp = c;
      this.editModal = true;
    },
    deleteCamp(c) {
      this.$confirmMessage(
        { title: `¿Esta seguro que desea borrar ${c.name}?` },
        () => {
          return catalogService
            .delete("highway/camp", c, { source: this.camps })
            .catch(this.$fireErrorResponse);
        }
      );
    },
    updateCamp({ original, updated, residentChanged }) {
      this.hideEdit();
      if (!original.id) {
        catalogService
          .create("highway/camp", updated, { source: this.camps })
          .then((camp) =>
            this.$successMessage({
              title: `Creado nuevo campamento: ${camp.name}`,
            })
          )
          .catch(this.$fireErrorResponse);
      } else if (!residentChanged) {
        this.doCampUpdate(updated, original);
      } else {
        this.approveResidentChange(residentChanged)
          .then(() => {
            this.updatingCampResident = true;
            this.doCampUpdate(updated, original)
              .then(() => {
                this.updatingCampResident = false;
              })
              .catch(() => {
                this.updatingCampResident = false;
              });
          })
          .catch(() => {
            this.$alertMessage({
              title: "Accion cancelada",
              text: "No se realizaron cambios",
            });
          });
      }
    },
    approveResidentChange() {
      return new Promise((resolve, reject) => {
        this.$fire({
          title: "Cambio de residente",
          text: "Se procedera a reasignar los siniestros activos.",
          icon: "warning",
          allowOutsideClick: false,
          showCancelButton: true,
          cancelButtonText: "Cancelar",
        }).then(({ isConfirmed }) => {
          if (isConfirmed) {
            resolve();
            return;
          }
          reject();
        });
      });
    },
    doCampUpdate(updated, original) {
      return catalogService
        .update("highway/camp", updated, original, { source: this.camps })
        .then(
          (camp) => {
            this.updatingCampResident = false;
            this.$successMessage({ title: `${camp.name} fue actualizado.` });
          },
          (error) => {
            this.updatingCampResident = false;
            this.$fireErrorResponse(error);
          }
        );
    },
    addCamp() {
      this.modalFunction = false;
      this.editModalTitle = "Agregar campamento";
      this.currentCamp = {};
      this.editModal = true;
    },
    hideEdit() {
      this.editModal = false;
    },
  },
  mounted() {
    catalogService.fetch("common/states", { useStore: true });
    catalogService.fetch("highway", { useStore: true });
    catalogService.fetch("highway/camp").then((camps) => (this.camps = camps));
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Catalogs/Camp/Index.vue